import React from "react";
import { Nav } from "ui-kit-ck-consultant";
import FadeIn from "react-fade-in";

import AuthContext from "../../context/AuthContext";
import ContactRequest from "./ContactRequest";

// Gates a page on the flag its registry entry declares. It sits between the layout
// and the page, so a page the user may not open is never mounted at all — no
// constructor, no componentDidMount, no data call fired before being told "no".
//
// A page the company can see but not open (displayed && !clickable) is still routed:
// it renders the "request access" form instead of the content. That teaser is the
// upsell funnel, so denying access must never mean 404.
export default class RightGuard extends React.Component {
  static contextType = AuthContext;

  render() {
    const { right, adminOnly, superAdmin, teaserTitle, contactPage } = this.props;

    if (adminOnly) {
      // Same rule as before: a user with no company is the global super-admin.
      return this.context.admin === true || !this.context.companyId ? (
        this.props.children
      ) : (
        <h2>
          Oups... Vous n'avez pas les autorisations nécessaires pour accéder à cette
          page...
        </h2>
      );
    }

    // The super-admin has no company and therefore no flags; the registry marks the
    // pages they must reach anyway.
    if (superAdmin && !this.context.companyId) return this.props.children;

    if (!right) return this.props.children;

    // Read from context, never from a prop: the routes are computed once per rights
    // change, so a `clickable` snapshot passed down would go stale.
    const allowed = !!(((this.context.access || {}).clickable || {})[right]);
    if (allowed) return this.props.children;

    return (
      <FadeIn>
        <Nav title={teaserTitle} className="mb-20" />
        <ContactRequest page={contactPage} />
      </FadeIn>
    );
  }
}
